import React, { useState, useEffect, useRef, Suspense } from 'react';
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { cambiaHotel } from '../actions'
//import Header from "../containers/header";
import Header from "../components/Header";
import Footer from "../components/footer";
import Toast from "../components/toast_mod"
import Notificaciones from "./notificaciones";
import { useQuery } from '@tanstack/react-query'
import { getIni } from '../services';
import { SET_CONTAINI } from '../actions/constants';

const LayoutPrincipal = (props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation();

    const {usuario, conta} = useSelector((state) => state)
    const isMounted = useRef(false);

    const { data: data_ini, refetch: refetch_ini, isLoading: isLoadingIni, isError: isErrorIni } = useQuery({
        queryKey: ['cashbook_ini'],
        queryFn: getIni,
        staleTime: 1000 * 60, // 1 min	
    });

    // Restore the last selected hotel from localStorage after the user is authenticated.
    // Runs after CHK_USER / LOG_USER so it wins over the backend default.
    // Falls back to hotel 4 if the stored hotel is not in the user's allowed units.
    useEffect(() => {
        if (!usuario.user || !usuario.unidades) return;
        const stored = parseInt(localStorage.getItem("id_hotel"));
        const isAvailable = stored && usuario.unidades.hasOwnProperty(String(stored));
        const firstAvailable = parseInt(Object.keys(usuario.unidades)[0]);
        const target = isAvailable ? stored : (firstAvailable || 4);
        if (target !== usuario.id_hotel_def) {
            dispatch(cambiaHotel(target));
        }
    }, [usuario.user]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!localStorage.getItem("isAuthenticate")) navigate("/login", { replace: true });
    }, [navigate])

    useEffect(() => {
        ////console.log("Cambio estado usuario en layoyt principal")
        if (isMounted.current) {
            if (!localStorage.getItem("isAuthenticate") || localStorage.getItem("isAuthenticate") === "false") {
                if (localStorage.getItem("BelieveToken") !== null) localStorage.removeItem("BelieveToken");
                if (localStorage.getItem("isAuthenticate") !== null) localStorage.removeItem("isAuthenticate")
                navigate('/login', { replace: true })
            }
        } else {
            isMounted.current = true;
        }
    }, [usuario.logueado])

    useEffect(() => {
        ////console.log(data_ini)
        if (data_ini) dispatch({ type: SET_CONTAINI, payload: data_ini.data })
    }, [data_ini])

    const checkeaPermisos = () => {
        //const route = permisos[menu_rel[usuario.user.rol]].find(permiso => location.pathname.includes(permiso.dest) && usuario.user.rol <= permiso.minrol)
        const route = [...usuario.allowed_dest,"/booking_admin","/receipt_pdf"].some(path => location.pathname.startsWith(path));
        return location.pathname === "/" || location.pathname === "/login" || route
    }

    if (isLoadingIni) return <h5>Loading...</h5>
    if (isErrorIni) return <h5>Error...</h5>

    return (
        <>
            {usuario.user && localStorage.getItem("isAuthenticate") && <Header history={props.history} />}
            <Toast />
            <Notificaciones />
            <div style={{ marginTop: localStorage.getItem("isAuthenticate") ? "90px" : "0px" }}>
                {usuario.user && usuario.user.rol && conta.monedas.length > 0 ?
                    <Suspense fallback={<h5>Loading...</h5>}>
                        {checkeaPermisos() ?
                            <Outlet />
                            :
                            <h5>No tiene permiso para ingresar a esta seccion.</h5>
                        }
                    </Suspense>
                    :
                    <h5>Loading Initial Data...</h5>
                }
            </div>
            {usuario.user && localStorage.getItem("isAuthenticate") && <Footer />}
        </>
    )
}

export default LayoutPrincipal;
